"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _clsx = _interopRequireDefault(require("clsx"));

var _Select = _interopRequireDefault(require("./Select.style"));

var _utils = _interopRequireDefault(require("../utils/utils"));

var _TextField = _interopRequireDefault(require("../TextField"));

var _PortalWrapper = _interopRequireDefault(require("../PortalWrapper"));

var _Menu = _interopRequireDefault(require("../Menu"));

var _dec, _class;

let Select = (_dec = (0, _reactJss.default)(_Select.default), _dec(_class = class Select extends _react.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selected: false,
      activeTitle: null,
      filter: ''
    };
    this.handleMenuItemClick = this.handleMenuItemClick.bind(this);
    this.handleMenuClose = this.handleMenuClose.bind(this);
    this.handleTextFieldFocus = this.handleTextFieldFocus.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  static getDerivedStateFromProps(props) {
    const {
      value
    } = props;
    let find;
    const {
      children
    } = props;

    if (!value || !value.length) {
      return {
        activeTitle: null
      };
    }

    _react.default.Children.forEach(children, child => {
      const childValue = child.props.value || '';
      const childValueF = childValue.toString().toLowerCase();
      const valueF = value.toString().toLowerCase();

      if (childValueF === valueF) {
        find = child;
      }
    });

    if (find) {
      return {
        activeTitle: find.props.label
      };
    }

    return {
      activeTitle: value
    };
  }

  handleMenuItemClick({
    value
  }) {
    let error = false;
    const {
      id,
      required
    } = this.props;

    if (required && typeof value === 'undefined') {
      error = true;
    }

    this.props.onChange({
      id,
      value,
      error
    });
    this.setState({
      selected: false
    });
  }

  handleTextFieldFocus() {
    this.setState({
      selected: true
    });
  }

  handleMenuClose() {
    this.setState({
      selected: false
    });
  }

  handleInputChange({
    value
  }) {
    let error = false;
    const {
      id,
      required
    } = this.props;

    if (required) {
      error = true;
    }

    this.props.onInputChange({
      id,
      value,
      error
    });
    this.setState({
      filter: value
    });
  }

  renderList() {
    const {
      filter
    } = this.state;
    const {
      children
    } = this.props;
    if (!children) return null;
    if (!filter) return children;

    const searchRegExp = _utils.default.escapeRegExp(filter.slice(0, 255));

    return _react.default.Children.toArray(children).filter(child => child.props.label.match(searchRegExp));
  }

  renderTextField({
    classes,
    label,
    error,
    helperText,
    visibility,
    bordered,
    size,
    leftIcon,
    type,
    placeholder
  }) {
    const {
      autoFocus
    } = this.props;
    return _react.default.createElement(_TextField.default, {
      className: classes.edit,
      label: label,
      error: error,
      helperText: helperText,
      value: this.state.activeTitle || this.state.filter,
      inputMode: type === 'autocomplete' ? 'text' : 'none',
      rightIcon: "dropdown",
      placeholder: placeholder,
      leftIcon: leftIcon,
      visibility: visibility,
      autoFocus: autoFocus,
      onFocus: this.handleTextFieldFocus,
      toggleFocus: true,
      onChange: this.handleInputChange,
      readOnly: type !== 'autocomplete',
      autoSelect: type === 'autocomplete',
      size: size,
      bordered: bordered
    });
  }

  renderMenu({
    id,
    classes,
    visibility
  }) {
    const {
      selected
    } = this.state;
    const {
      portalOptions
    } = this.props;
    if (!selected || visibility === 'disabled') return null;

    const menu = _react.default.createElement(_Menu.default, {
      id: id,
      className: (0, _clsx.default)(classes.menu),
      openType: this.props.openType,
      onClick: this.handleMenuItemClick,
      onClose: this.handleMenuClose,
      visibility: selected ? 'visible' : 'hidden',
      activeItem: this.props.value
    }, this.renderList());

    if (!portalOptions) return menu;
    return _react.default.createElement(_PortalWrapper.default, (0, _extends2.default)({
      node: this.txtEl,
      width: this.txtEl.clientWidth || 'auto',
      offsetY: this.txtEl.clientHeight || 0
    }, portalOptions), menu);
  }

  render() {
    const {
      classes,
      id,
      className,
      visibility,
      type,
      label,
      error,
      helperText,
      children,
      bordered,
      leftIcon,
      size,
      placeholder
    } = this.props;
    return _react.default.createElement("div", {
      ref: el => {
        this.txtEl = el;
      },
      id: id,
      className: (0, _clsx.default)(className, classes.select)
    }, this.renderTextField({
      classes,
      label,
      error,
      helperText,
      visibility,
      bordered,
      size,
      leftIcon,
      type,
      placeholder
    }), this.renderMenu({
      id,
      classes,
      children,
      visibility
    }));
  }

}) || _class);
Select.defaultProps = {
  children: null,
  id: null,
  visibility: 'visible',
  error: false,
  bordered: false,
  type: 'default',
  onChange: () => {},
  onInputChange: () => {}
};
var _default = Select;
exports.default = _default;